<template>
  <div class="space-y-4">
    <div v-if="schedulingMode === 'none'" class="flex flex-col gap-3">
      <Label>{{ optional ? 'Schedule a meeting (optional)' : 'How would you like to schedule the interview?' }}</Label>
      <div v-if="isLoading" class="spinner" />
      <template v-else>
        <Button class="flex-1" :disabled="!isReady" v-bind="adminButtonProps"> I'll choose the day & time </Button>
        <Button variant="outline" class="flex-1" :disabled="!isReady" @click="schedulingMode = 'candidate_choose'">
          Let candidate choose
        </Button>
        <p v-if="!isReady" class="text-sm text-muted-foreground">
          To schedule an interview, {{ settingsHint.text }} in
          <Button variant="minimal" as="a" :href="settingsHint.href" target="_blank">Settings</Button>.
        </p>
      </template>
    </div>

    <AdminScheduleInput
      v-if="schedulingMode === 'admin_schedule'"
      :input="adminSchedule"
      @back="schedulingMode = 'none'"
    />

    <CandidateScheduleInput
      v-if="schedulingMode === 'candidate_choose'"
      :input="candidateSchedule"
      @back="schedulingMode = 'none'"
    />
  </div>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import AdminScheduleInput from './AdminScheduleInput.vue';
import CandidateScheduleInput from './CandidateScheduleInput.vue';
import type { UseScheduleInterviewInputReturn } from './useScheduleInterviewInput';

type Props = {
  input: UseScheduleInterviewInputReturn;
  optional?: boolean;
};

const props = withDefaults(defineProps<Props>(), { optional: false });
const { schedulingMode, adminSchedule, candidateSchedule, isLoading, isReady, settingsHint, adminButtonProps } =
  props.input;
</script>
